import { ANNUAL_REPORTS_TYPES } from './annualReportsTypes';

const initialState = {
  data: null,
  count: 0,
  totalBooking: 0,
  totalRevenue: 0,
  rows: [],
  loading: false,
  error: null,
  success: false
};

const annualReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ANNUAL_REPORTS_TYPES.FETCH_ANNUAL_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };

    case ANNUAL_REPORTS_TYPES.FETCH_ANNUAL_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
        count: action.payload.count || 0,
        totalBooking: action.payload.total_booking || 0,
        totalRevenue: action.payload.total_revenue || 0,
        rows: action.payload.rows || []
      };

    case ANNUAL_REPORTS_TYPES.FETCH_ANNUAL_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case ANNUAL_REPORTS_TYPES.CLEAR_ANNUAL_REPORTS:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default annualReportsReducer;